import React from 'react';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import { Icon } from 'design-comuni-plone-theme/components/ItaliaTheme';

const BlockSearchRubricaBodySkeleton = () => {
    return (
        <div className="public-ui searchRubrica">
            <div className="searchRubrica-background" />
            <div className="ui container">
                {/* Intestazione e barra di ricerca */}
                <div className="searchContainer d-flex w-100 flex-column mt-5">
                    <h3 className="search-rubrica-title text-primary mb-3">
                        <Skeleton width={220} height={28} />
                    </h3>

                    <div className="searchbar shadow-sm d-flex w-100">
                        <button
                            type="button"
                            className="rounded-start"
                            disabled
                            aria-hidden="true"
                            style={{
                                backgroundColor: '#eee',
                                border: 'none',
                                padding: '0.5rem 1rem',
                            }}
                        >
                            <Icon icon="it-search" padding={false} size="md" />
                        </button>
                        <input
                            className="inputSearch rounded-end"
                            disabled
                            style={{
                                width: '100%',
                                backgroundColor: '#eee',
                                border: 'none',
                                padding: '0.5rem',
                            }}
                            aria-hidden="true"
                        />
                    </div>
                </div>

                {/* Simulazione dei testi helper */}
                <div className="mt-4">
                    <Skeleton width="40%" height={20} className="mb-2" />
                    <Skeleton width="60%" height={20} className="mb-2" />
                    <Skeleton width="30%" height={20} />
                </div>

                {/* Simulazione sezione finale */}
                <div className="mt-5 text-center">
                    <Skeleton width="50%" height={25} />
                </div>
            </div>
        </div>
    );
};

export default BlockSearchRubricaBodySkeleton;
